module.exports = __webpack_public_path__ + "img/2.53201625.jpg";